const formatToIndianCurrency = (
    value: any,
    addSymbol: boolean = false
): string | any => {
    if (value) {
        if (isNaN(value)) {
            return value;
        }
        if (addSymbol) {
            return (
                <>
                    <span className="rupee">₹</span>
                    {Number(value).toLocaleString("en-IN")}{" "}
                </>
            );
        }
        return Number(value).toLocaleString("en-IN");
    }
    if (value || value === 0) {
        if (addSymbol) {
            return (
                <>
                    <span className="rupee">₹</span>{value}
                </>
            )
        }
    }
    return value;
};

export default formatToIndianCurrency;
